export const PageHeader = ({ eyebrow, title, description, actions, testid = "page-header" }) => (
  <div data-testid={testid} className="mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
    <div className="max-w-2xl">
      {eyebrow && <p className="mb-2 text-sm font-medium text-muted-foreground">{eyebrow}</p>}
      <h1 className="text-xl font-semibold text-foreground" data-testid={`${testid}-title`}>
        {title}
      </h1>
      {description && <p className="mt-2 text-sm text-muted-foreground md:text-base">{description}</p>}
    </div>
    {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
  </div>
);
